import { cn } from "../lib/utils";

export const DIRECT_TEXT_INPUT_SOURCE = "direct-text-input";

function getHttpSourceUrl(source: string): string | null {
  try {
    const url = new URL(source);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.toString()
      : null;
  } catch {
    return null;
  }
}

export function PostSource({
  source,
  className,
}: {
  source: string;
  className?: string;
}) {
  const label =
    source === DIRECT_TEXT_INPUT_SOURCE ? "Direct Text Input" : source;
  const href = getHttpSourceUrl(source);

  if (!href) {
    return (
      <span className={cn("text-gray-700", className)} title={label}>
        {label}
      </span>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("text-blue-600 hover:underline", className)}
      title={source}
    >
      {source}
    </a>
  );
}
